import tv from "typed-object-validator";

export type Language = "nl" | "fr" | "nl_nl";
export const LanguageSchema = tv.value("nl").or(tv.value("fr")).or(tv.value("nl_nl"));
export const LanguageValues = ["nl", "fr", "nl_nl"];

/**
 * @param hostname Use window.location.hostname on client side
 */
export function getLanguageForHostname(hostname: string): Language {
    switch (hostname) {
        case "etudes-consumerhouse.be":
        case "www.etudes-consumerhouse.be":
            return "fr";
        case "onderzoeken-consumerhouse.nl":
        case "www.onderzoeken-consumerhouse.nl":
            return "nl_nl";
        default:
        case "onderzoeken-consumerhouse.be":
        case "www.onderzoeken-consumerhouse.be":
            return "nl";
    }
}

export function getSpeakLanguageForHostname(hostname: string): Language {
    switch (hostname) {
        case "etudes-consumerhouse.be":
        case "www.etudes-consumerhouse.be":
            return "fr";
        default:
        case "onderzoeken-consumerhouse.nl":
        case "www.onderzoeken-consumerhouse.nl":
        case "onderzoeken-consumerhouse.be":
        case "www.onderzoeken-consumerhouse.be":
            return "nl";
    }
}

export function getUrlForLanguage(language: Language) {
    switch (language) {
        case "fr":
            return "https://etudes-consumerhouse.be";
        case "nl_nl":
            return "https://onderzoeken-consumerhouse.nl";
        default:
        case "nl":
            return "https://onderzoeken-consumerhouse.be";
    }
}
